import { FC, useMemo } from 'react';

import { MyRepayment } from 'src/hygiene/sections/FinanceCalculator/components/MyRepayment/MyRepayment';

interface FinancePdpCalculatorProps {
  productPrice: number;
  interestRateRange: {
    minRate: number;
    maxRate: number;
  };
  loanTerms: {
    min: number;
    max: number;
  };
}

export const FinancePdpCalculator: FC<FinancePdpCalculatorProps> = ({ productPrice, interestRateRange, loanTerms }) => {
  const loanTermsArray = useMemo(
    () => Array.from({ length: loanTerms.max - loanTerms.min + 1 }, (_value, index) => loanTerms.min + index),
    [loanTerms],
  );

  return (
    <div className="rounded-lg border-0 border-bor-neu-mut bg-bac-tie1" data-testid="finance-calculator-form">
      <div className="px-4 pt-6 pb-4 md:p-6">
        <MyRepayment
          loanTermsArray={loanTermsArray}
          interestRateRange={interestRateRange}
          productPrice={productPrice}
        />
      </div>
    </div>
  );
};
